import emBranco from './em-branco';
import paginaDeHotel from './pagina-de-hotel';
import blackFridayAquecimento from './black-friday-aquecimento';
import blackFridayComecou from './black-friday-comecou';
import blackFridayComecouRede from './black-friday-comecou-rede';
import blackFridayJaAcabou from './black-friday-ja-acabou';
import blackFridayEsquenta from './black-friday-esquenta';
import blackFridayPre from './black-friday-pre';
import blackMonday from './black-monday';
import listaVipBlack from './lista-vip-black';
import conteudos from './conteudos';
import conteudosInterna from './conteudo-interna';
import redeDeHoteis from './rede-de-hoteis';
import preCheckIn from './pre-check-in';

export default [
  emBranco,
  paginaDeHotel,
  blackFridayAquecimento,
  blackFridayComecou,
  blackFridayComecouRede,
  blackFridayJaAcabou,
  blackFridayEsquenta,
  blackFridayPre,
  blackMonday,
  listaVipBlack,
  conteudos,
  conteudosInterna,
  redeDeHoteis,
  preCheckIn,
];
